const doc = [({"en":({"js":({"admin":({"communication":({"bottom_bar":({"ready_to_send":"Ready to send"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;